class ArticleScrollSpy {
    constructor() {
        this.tocLinks = document.querySelectorAll('.article-toc__link');
        this.headings = [];
        this.currentActive = null;
        this.observer = null;

        if (this.tocLinks.length > 0) {
            this.init();
        }
    }

    init() {
        // Collect all heading elements
        this.tocLinks.forEach(link => {
            const targetId = link.dataset.target;
            const element = document.getElementById(targetId);
            if (element) {
                this.headings.push({
                    id: targetId,
                    element: element,
                    link: link
                });
            }
        });

        // Use Intersection Observer for performance
        this.setupObserver();
    }

    setupObserver() {
        const options = {
            root: null,
            rootMargin: '-20% 0px -70% 0px', // Active when in the upper third of viewport
            threshold: 0
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const targetId = entry.target.id;
                    this.setActiveLink(targetId);
                }
            });
        }, options);

        // Observe all headings
        this.headings.forEach(heading => {
            this.observer.observe(heading.element);
        });
    }

    setActiveLink(targetId) {
        // Remove active class from current global active
        if (this.currentActive) {
            this.currentActive.classList.remove('active');
        }

        // Find new active heading object
        const newActiveHeading = this.headings.find(h => h.id === targetId);

        if (newActiveHeading) {
            const link = newActiveHeading.link;
            link.classList.add('active');
            this.currentActive = link;

            // Auto-expand logic
            this.handleAutoExpand(link);

            // Scroll ToC to keep active item visible
            this.scrollTocToActive(link);
        }
    }

    handleAutoExpand(activeLink) {
        // If active link is an H3, ensure parent H2 is expanded
        if (activeLink.classList.contains('article-toc__link--h3')) {
            const parentList = activeLink.closest('.article-toc__h3-list');
            if (parentList) {
                parentList.classList.add('visible'); // Show list
                // Find parent H2 link
                const parentItem = parentList.closest('.article-toc__item--h2');
                const parentLink = parentItem ? parentItem.querySelector('.article-toc__link--h2') : null;
                if (parentLink) {
                    parentLink.classList.add('expanded');
                    parentLink.classList.add('active'); // Keep parent highlighted too
                }
            }
        }
        // If we scroll back to an H2 that has children, we might want to collapse others? 
        // For now, let's keep it simple: just expand what's needed.
    }

    scrollTocToActive(link) {
        const tocSidebar = document.querySelector('.article-toc-sidebar');
        // Also support mobile drawer scrolling
        const drawerContent = document.querySelector('.drawer__content');

        const container = tocSidebar && getComputedStyle(tocSidebar).display !== 'none'
            ? tocSidebar
            : drawerContent;

        if (!container) return;

        // Use scrollIntoView logic specifically for the ToC list container
        // The link is inside .article-toc__list (or nested) which is inside .article-toc which scrolls

        const tocListContainer = document.querySelector('.article-toc');
        if (tocListContainer) {
            const linkRect = link.getBoundingClientRect();
            const containerRect = tocListContainer.getBoundingClientRect();

            // Check if link is outside visible area of the scrollable ToC container
            if (linkRect.top < containerRect.top || linkRect.bottom > containerRect.bottom) {
                link.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new ArticleScrollSpy();
    });
} else {
    new ArticleScrollSpy();
}
